import { type Set as ImSet, Record } from 'immutable';

import { resourceStoreTypes } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const USERINFO_REDUCER_KEY = 'userInfoStore';
export type USERINFO_REDUCER_KEY = typeof USERINFO_REDUCER_KEY;

export interface UserInfoProps {
  alwaysMfaMe?: boolean;
  defaultChannel?: string;
  email?: string;
  entitlements?: ImSet<string>;
  expiration?: string | null;
  groups?: string;
  id: string;
  phone?: string;
  source?: string;
  tokenIssuedAt?: string | null;
  userCreatedAt?: string;
  userId?: string;
  username?: string;
}

export const mkUserinfo = Record<UserInfoProps>({
  alwaysMfaMe: undefined,
  defaultChannel: undefined,
  email: undefined,
  entitlements: undefined,
  expiration: undefined,
  groups: undefined,
  id: 'me',
  phone: undefined,
  source: undefined,
  tokenIssuedAt: undefined,
  userCreatedAt: undefined,
  userId: undefined,
  username: undefined,
});
export const mkUserInfoStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<UserInfoProps>({
  resourceName: 'TAGS',
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [USERINFO_REDUCER_KEY]: QcsSyncResourceStore<UserInfoProps>;
  }
}
